import * as types from './documentMasterActionType';

export const getDocumentTypesRequest = (data) =>{
    
    return ({
    type: types.GET_DOCUMENT_TYPES_MASTER_REQUEST,
    payload: data,
});
}
export const getDocumentTypesSuccess = (data) => ({
    type: types.GET_DOCUMENT_TYPES_MASTER_SUCCESS,
    payload: data,
});

export const getDocumentTypesFailure = (error) => ({
    type: types.GET_DOCUMENT_TYPES_MASTER_FAILURE,
    payload: error,
});

export const saveDocumentTypeRequest = (data) => ({
    type: types.SAVE_DOCUMENT_TYPE_REQUEST,
    payload: data,
});

export const saveDocumentTypeSuccess = (data) => ({
    type: types.SAVE_DOCUMENT_TYPE_SUCCESS,
    payload: data,
});

export const saveDocumentTypeFailure = (error) => ({
    type: types.SAVE_DOCUMENT_TYPE_FAILURE,
    payload: error,
});

export const deleteDocumentTypeRequest = (data) => ({
    type: types.DELETE_DOCUMENT_TYPE_REQUEST,
    payload: data,
});

export const deleteDocumentTypeSuccess = (data) => ({
    type: types.DELETE_DOCUMENT_TYPE_SUCCESS,
    payload: data,
});

export const deleteDocumentTypeFailure = (error) => ({
    type: types.DELETE_DOCUMENT_TYPE_FAILURE,
    payload: error,
});

export const getDocumentTypeByIdRequest = (data) => ({
    type: types.GET_DOCUMENT_TYPE_BY_ID_REQUEST,
    payload: data,
});

export const getDocumentTypeByIdSuccess = (data) => ({
    type: types.GET_DOCUMENT_TYPE_BY_ID_SUCCESS,
    payload: data,
});

export const getDocumentTypeByIdFailure = (error) => ({
    type: types.GET_DOCUMENT_TYPE_BY_ID_FAILURE,
    payload: error,
});
